var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1cb2ad98c867c5e32b55981e3cfde8ef.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ceca7127f306ee27daace3860bf7a29d.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ff21d374f740cd2133c5da157ac232d2.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    